import { useState } from "react";
import { Link } from "react-router-dom";
import Sideform from "../servicePage/Sideform";

const ContactUsPage = () => {
  const [activeAccordion, setActiveAccordion] = useState(null);

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  const faqs = [
    {
      question: "What services does your clinic offer?",
      answer:
        "We offer a wide range of skincare treatments tailored to meet your specific needs. Our services include facials, chemical peels, microdermabrasion, anti-aging treatments, acne management, and more.",
    },
    {
      question: "How do I know which treatment is right for me?",
      answer:
        "During your consultation, our experienced team will assess your skin's condition, discuss your concerns and goals, and recommend a personalized treatment plan that suits your needs.",
    },
    {
      question: "What can I expect during my first visit?",
      answer:
        "Your first visit will begin with a warm welcome from our friendly staff. We'll start with a detailed consultation to understand your skin's history and your goals.",
    },
    {
      question: "Are the treatments safe for all skin types?",
      answer:
        "Yes, our treatments are safe and effective for all skin types. Our team of experts is highly trained in treating a variety of skin concerns across different skin types and tones.",
    },
    {
      question: "How often should I schedule treatments?",
      answer:
        "The frequency of your treatments will depend on the specific service you're receiving and your individual skin needs. During your consultation, we'll discuss a treatment schedule.",
    },
  ];

  return (
    <div className="contact-page heading-margin">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <h1>Contact Us</h1>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="contact-info-section">
        <div className="container">
          <div className=" mb-3">
            <Link to="/">Home</Link> / <span>Contact Us</span>
          </div>
          <div className="contact-grid">
            {/* Contact Details */}

            <div className="contact-details">
              <h2>Get In Touch With Us!</h2>

              <div className="contact-method">
                <h3>Phone</h3>
                <p>
                  <i
                    className="fa-brands fa-whatsapp"
                    style={{ marginRight: "10px" }}
                  ></i>
                  <i
                    className="fa-solid fa-phone"
                    style={{ marginRight: "10px" }}
                  ></i>
                  <span>+971 55 120 0086</span>
                  <br />
                  <i
                    className="fa-solid fa-phone"
                    style={{ marginRight: "10px" }}
                  ></i>
                  +971 4 547 9492
                </p>
              </div>

              <div className="contact-method">
                <h3>Email</h3>
                <p>
                  <strong>For General matters:</strong>
                  <br />
                  contact@elitebodyhome.com
                  <br />
                  <strong>For Suggestions & Complains</strong>
                  <br />
                  feedback@elitebodyhome.com
                  <br />
                  <strong>Strategic & B2B matters</strong>
                  <br />
                  mohammed@elitebodyhome.com
                </p>
              </div>

              <div className="contact-method">
                <h3>Address</h3>
                <p>
                  Elite Body Home Poly Clinic L.L.C
                  <br />
                  1st Floor Office 117 Block B<br />
                  Al Hudaiba Awards Building 2nd December Interchange
                  <br />
                  Jumeirah St. Dubai, UAE
                </p>
              </div>
            </div>

            {/* Map */}
            <div className="contact-map">
              <iframe
                title="Clinic Location"
                src="https://maps.google.com/maps?q=Elite%20Body%20Home%20Aesthetic%20Polyclinic&t=m&z=14&output=embed&iwloc=near"
                allowFullScreen
                loading="lazy"
              ></iframe>
            </div>

            {/* Contact Form */}
            <div className="contact-form-container">
              <Sideform />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="container">
          <h2>Frequently Asked Questions</h2>

          <div className="accordion">
            {faqs.map((faq, index) => (
              <div className="accordion-item" key={index}>
                <button
                  className={`accordion-header ${
                    activeAccordion === index ? "active" : ""
                  }`}
                  onClick={() => toggleAccordion(index)}
                >
                  {faq.question}
                  <span className="accordion-icon">
                    {activeAccordion === index ? "−" : "+"}
                  </span>
                </button>
                <div
                  className={`accordion-content ${
                    activeAccordion === index ? "open" : ""
                  }`}
                >
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CSS Styles */}
      <style jsx>{`
        .contact-page {
          font-family: "Arial", sans-serif;
          // color: #333;
        }

        /* Hero Section */
        .contact-hero {
          background-size: cover;
          background-position: center;
          padding: 100px 0;
          text-align: center;
          color: white;
          position: relative;
        }

        .contact-hero::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
        }

        .contact-hero .container {
          position: relative;
          z-index: 1;
        }

        .contact-hero h1 {
          font-size: 48px;
          margin-bottom: 15px;
        }

        .breadcrumb {
          font-size: 16px;
        }

        .breadcrumb a {
          color: white;
          text-decoration: none;
        }

        .breadcrumb span {
          color: #f0f0f0;
        }

        /* Contact Info Section */
        .contact-info-section {
          padding: 80px 0;
          // background-color: #c69933;
        }

        .contact-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px;
        }

        @media (max-width: 992px) {
          .contact-grid {
            grid-template-columns: 1fr;
          }
        }

        .contact-details,
        .contact-form-container {
          background: white;
          padding: 30px;
          border-radius: 8px;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
        }

        .contact-details h2,
        .contact-form-container h2 {
          font-size: 28px;
          margin-bottom: 20px;
          color: #222;
        }

        .contact-method {
          margin-bottom: 25px;
        }

        .contact-method h3 {
          font-size: 18px;
          color: #555;
          margin-bottom: 10px;
        }

        .contact-method p {
          line-height: 1.6;
        }

        .contact-map {
          height: 100%;
          min-height: 400px;
          border-radius: 8px;
          overflow: hidden;
        }

        .contact-map iframe {
          width: 100%;
          height: 100%;
          border: none;
        }

        /* Contact Form */
        .contact-form {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .form-group {
          display: flex;
          flex-direction: column;
        }

        .form-group label {
          margin-bottom: 8px;
          font-weight: 500;
        }

        .form-group input {
          padding: 12px 15px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 16px;
        }

        .submit-btn {
          background-color: #c69933;
          color: white;
          border: none;
          padding: 14px 20px;
          border-radius: 4px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: background-color 0.3s;
        }

        .submit-btn:hover {
          background-color: #c69933;
        }

        /* FAQ Section */
        .faq-section {
          padding: 80px 0;
          background: white;
        }

        .faq-section h2 {
          text-align: center;
          font-size: 32px;
          margin-bottom: 40px;
        }

        .accordion {
          max-width: 800px;
          margin: 0 auto;
        }

        .accordion-item {
          margin-bottom: 15px;
          border: 1px solid #eee;
          border-radius: 8px;
          overflow: hidden;
        }

        .accordion-header {
          width: 100%;
          padding: 18px 20px;
          background: #f0f0f0;
          border: none;
          text-align: left;
          font-size: 18px;
          font-weight: 500;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          transition: background 0.3s;
        }

        .accordion-header:hover {
          background: #c69933;
        }

        .accordion-header.active {
          background: #c69933;
          color: white;
        }

        .accordion-icon {
          font-size: 20px;
          font-weight: bold;
        }

        .accordion-content {
          padding: 0 20px;
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s ease-out, padding 0.3s ease;
        }

        .accordion-content.open {
          padding: 20px;
          max-height: 300px;
        }

        .accordion-content p {
          line-height: 1.6;
        }
      `}</style>
    </div>
  );
};

export default ContactUsPage;
